import React, { Component } from 'react';
import './individual-editor.scss';
import './individual-editor-desktop.scss';
import { connect } from 'react-redux';
import UILoadingPage from '../../../../components/UI/UILoadingPage/UILoadingPage';
import { withApollo } from '@apollo/react-hoc';
import { getInitialRoute, isUserAdminOrRM } from '../../../../utils/Helpers/UserHelpers';
import UIButton from '../../../../components/UI/UIButton/UIButton';
import PLTable from '../../../../components/PL/PLTable/PLTable';
import UILabeledInput from '../../../../components/UI/UILabeledInput';
import Queries from '../../../../utils/API/Queries';
import { PlusIcon } from '../../../../assets/icons';
import { OPTION_EDITOR_CERTIFICATIONS_DROPDOWN_VALUES, USER_ROLE_EDITING_MANAGER } from '../../../../utils/Config/Constants';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../components/UI/UISearchBar';
import UIHover from '../../../../components/UI/UIHover/UIHover';
import PLFilters from '../../../../components/PL/PLFilters';
import APIHelper from '../../../../utils/Helpers/APIHelper';
import { EDITOR_CERTIFICATES_TAB, EDITOR_INFO_TAB, EDITOR_PAST_EDITS_TAB } from '../../../../utils/Config/MenuBodyTabs';
import Helmet from 'react-helmet';
import UIIconButton from '../../../../components/UI/UIIconButton';
import UIModal from '../../../../components/UI/UIModal';
import UIMenuBody, { filterSelectedItem } from '../../../../components/UI/UIMenuBody';
import UIOverlayCard from '../../../../components/UI/UIOverlayCard';
import { commonMapDispatchToProps, commonMapStateToProps } from '../../../../utils/Helpers/AppHelper';
import { SERVICES_TABLE_TYPE } from '../../../../components/PL/PLTable/config';
import { getPaginatedTableVariablesByTypeAndSearch } from '../../../../components/PL/PLTable/helpers';
import { UI_LABELED_INPUT_DROPDOWN_TYPE, UI_LABELED_INPUT_PHONE_NUMBER_TYPE, UI_LABELED_INPUT_TEXT_TYPE } from '../../../../components/UI/UILabeledInput/config';
import { PLFILTER_TYPE_SERVICE } from '../../../../components/PL/PLFilters/config';
import { UI_ICON_BUTTON_FILL_TYPE } from '../../../../components/UI/UIIconButton/config';
import { toast } from 'react-toastify';

class IndividualEditor extends Component {
	static QUERY_LIMIT = 20;

	images = [];

	constructor(props) {
		super(props);

		this.state = {
			editorServices: undefined
		};
	}

	//Mark: Lifecycle functions
	async componentDidMount() {
		await this.queryEditor();
		await this.queryServices();
	}

	errorCatch = (error) => {
		toast.error(error.message);
	};

	//Mark: Component functions

	getMenuItems = () => {
		return [EDITOR_INFO_TAB, EDITOR_CERTIFICATES_TAB, EDITOR_PAST_EDITS_TAB];
	};

	queryEditor = async () => {
		const response = await this.props.client.query({
			query: Queries.GET_USER_QUERY,
			variables: { id: this.props.match.params.id }
		});
		const { user: editor } = response['data'];
		if (editor) {
			this.setState(editor.certificates ? { editor } : { editor: { ...editor, certificates: [] } });
		}
	};

	queryServices = async () => {
		let baseVariables = { q: { editorId: { op_eq: this.props.match.params.id } } };
		let variables = getPaginatedTableVariablesByTypeAndSearch(IndividualEditor.QUERY_LIMIT, SERVICES_TABLE_TYPE, this.props, baseVariables);
		const response = await APIHelper.getRowsQuery(Queries.GET_SERVICES_WITH_QUERY, variables, this.props.client);
		const { services: editorServices } = response['data'];
		if (editorServices) {
			this.setState({ editorServices });
		}
	};

	onChangeUser = async (field, value) => {
		let editor = { ...this.state.editor, [field]: value };
		this.setState({ editor });
		const response = await this.props.client
			.mutate({
				mutation: Queries.UPDATE_USER_MUTATION,
				variables: { id: this.state.editor.id, [field]: editor[field] }
			})
			.catch(this.errorCatch);
		const { updateUser } = response['data'];
		if (updateUser) {
			toast.success(`Updated editor ${field}!`);
		}
	};

	toggleActive = async () => {
		let { isActive, id } = this.state.editor;
		isActive = !isActive;
		const response = await this.props.client
			.mutate({
				mutation: Queries.UPDATE_USER_MUTATION,
				variables: { id, isActive }
			})
			.catch(this.errorCatch);
		const { updateUser } = response['data'];
		if (updateUser) {
			let editor = { ...this.state.editor, isActive };
			this.setState({ editor });
		}
	};

	getAvailableCerts = () => {
		let array = OPTION_EDITOR_CERTIFICATIONS_DROPDOWN_VALUES;
		array = array.filter((x) => !this.state.editor.certificates.includes(x.value));
		return array;
	};

	addCertificationToUser = async () => {
		const { selectedValue, editor } = this.state;
		if (selectedValue) {
			let user = Object.assign({}, editor);
			let certifications = Object.assign([], user.certificates);
			certifications.push(selectedValue.value);

			const response = await this.props.client
				.mutate({
					mutation: Queries.UPDATE_USER_MUTATION,
					variables: { id: user.id, certificates: certifications }
				})
				.catch((error) => toast.error('Error adding certification! ' + error.message));
			if (response['data'].updateUser !== undefined) {
				user.certificates = certifications;
				this.setState({ editor });
				this.setState({ showAddCertModal: false });
				await this.queryEditor();
				toast.success('Successfully added certification!');
			} else {
				toast.error('Error adding certification!');
				this.setState({ showAddCertModal: false });
			}
		} else {
			toast.error('no certification selected');
		}
	};

	removeCertificationFromUser = async (certification) => {
		const { editor } = this.state;
		let user = Object.assign({}, editor);
		let certifications = Object.assign([], user.certificates);
		let index = certifications.indexOf(certification);
		if (index > -1) {
			certifications.splice(index, 1);
		}
		const response = await this.props.client
			.mutate({
				mutation: Queries.UPDATE_USER_MUTATION,
				variables: { id: user.id, certificates: certifications }
			})
			.catch((error) => toast.error('Error removing certification! ' + error.message));
		if (response['data'].updateUser) {
			user.certificates = certifications;
			this.setState({ showRemoveCertModal: false });
			toast.success('Successfully removed certification!');
			await this.queryEditor();
		} else {
			toast.error('Error removing certification');
			this.setState({ showRemoveCertModal: false });
		}
	};

	renderEditorCertificates = () => {
		const { certificates } = this.state.editor;

		if (!certificates) {
			return undefined;
		}
		return certificates.length > 0 ? (
			certificates.map((certification) => {
				return (
					<p
						key={certification}
						className='photographer-certification-text'
						onClick={() => this.setState({ showRemoveCertModal: true, certificationToRemove: certification })}>
						{certification}
					</p>
				);
			})
		) : (
			<p className='noCert'>this editor has no certifications yet</p>
		);
	};

	//Mark: Render functions
	render() {
		const { editor } = this.state;
		if (!editor) {
			return <UILoadingPage key={editor} />;
		}
		const menuItems = this.getMenuItems();
		return (
			<UIMenuBody menuTitle={editor.name} menuItems={menuItems}>
				<Helmet>
					<title>{editor.name} | Pineapple Labs</title>
					<meta property='og:title' content={`${editor.name} | Pineapple Labs`} />
				</Helmet>
				{this.renderAddEditorCertificationsModal()}
				{this.renderRemoveCertModal()}
				{this.renderSelectedPage(menuItems)}
			</UIMenuBody>
		);
	}

	renderSelectedPage = (menuItems) => {
		const { editor } = this.state;
		const selectedPage = filterSelectedItem(menuItems, this.props.location);
		switch (selectedPage) {
			case EDITOR_INFO_TAB:
				return (
					<div className='editorProfile__container'>
						<div className='editorProfile__container--card'>
							{isUserAdminOrRM(this.props.currentUser.user) && (
								<p
									onClick={() => {
										this.props.setSignedInUser(editor);
										this.props.history.push(getInitialRoute(editor) + this.props.location.search);
									}}>
									view as editor
								</p>
							)}
							<UILabeledInput
								label={'NAME'}
								className='width-100'
								containerStyle={{ width: 360 }}
								type={UI_LABELED_INPUT_TEXT_TYPE}
								onChangeValue={(value) => this.onChangeUser('name', value)}
								value={this.state.editor.name}
								placeholder={'Name...'}
							/>
							<UILabeledInput
								label={'EMAIL'}
								className='width-100'
								containerStyle={{ width: 360 }}
								type={UI_LABELED_INPUT_TEXT_TYPE}
								onChangeValue={(value) => this.onChangeUser('email', value)}
								value={this.state.editor.email}
								placeholder={'Email...'}
							/>
							<UILabeledInput
								label={'PHONE NUMBER'}
								type={UI_LABELED_INPUT_PHONE_NUMBER_TYPE}
								onChangeValue={(value) => this.onChangeUser('phoneNumber', value)}
								value={this.state.editor.phoneNumber}
								placeholder={'Phone number...'}
							/>
							{isUserAdminOrRM(this.props.currentUser.user) ? (
								<UIButton
									className='activate'
									key={this.state.editor.isActive}
									onClick={this.toggleActive}
									text={this.state.editor.isActive ? 'deactivate' : 're-activate'}
									type={this.state.editor.isActive ? UIButton.CANCEL_TYPE : UIButton.FILL_TYPE}
								/>
							) : undefined}
						</div>
					</div>
				);
			case EDITOR_CERTIFICATES_TAB:
				return (
					<div className='editorProfile__container'>
						{isUserAdminOrRM(this.props.currentUser.user) || this.props.currentUser.user.role === USER_ROLE_EDITING_MANAGER ? (
							<div className='certContainer'>
								<div className='certContainer__card'>
									<p className='certContainer__card--title'>Certifications:</p>
									<UIHover text={'add certification'}>
										<img
											className='certContainer__card--label'
											src={PlusIcon.mint}
											alt={'add'}
											onClick={() => this.setState({ showAddCertModal: true })}
										/>
									</UIHover>
								</div>
								<div className='certContainer__certs'>{this.renderEditorCertificates()}</div>
							</div>
						) : undefined}
					</div>
				);
			case EDITOR_PAST_EDITS_TAB:
				return (
					<div className='editor-past'>
						<p className='editor-services-title'>Editor services:</p>
						<div className='filter-services'>
							<PLFilters type={PLFILTER_TYPE_SERVICE} updateTable={this.queryServices} iconStyle={{ width: 28, height: 28, cursor: 'pointer' }} />
							<UISearchBar type={UI_SEARCH_BAR_TYPES.service} onSearchUpdated={this.queryServices} placeholder={'search...'} />
						</div>
						<PLTable
							type={SERVICES_TABLE_TYPE}
							limit={IndividualEditor.QUERY_LIMIT}
							updateTable={this.queryServices}
							data={this.state.editorServices}
							onSelect={(service) => this.props.history.push('/service/' + service.id)}
						/>
					</div>
				);
		}
	};
	renderAddEditorCertificationsModal = () => {
		const { showAddCertModal } = this.state;
		const hideModal = () => {
			this.setState({ showAddCertModal: false });
		};
		return (
			<UIModal condition={showAddCertModal} hideModal={hideModal}>
				<UIOverlayCard hideModal={hideModal} cardStyle={{ height: '100%' }} title={'Add a certification'}>
					<UILabeledInput
						type={UI_LABELED_INPUT_DROPDOWN_TYPE}
						options={this.getAvailableCerts()}
						containerStyle={{ width: 360, marginTop: 16 }}
						style={{ width: '100%' }}
						onChangeDropdownValue={(value) => this.setState({ selectedValue: value })}
						value={this.state.selectedValue}
						placeholder={'select a certification...'}
					/>
					<div className='general-buttons-container'>
						<UIIconButton dark icon={PlusIcon.grey} type={UI_ICON_BUTTON_FILL_TYPE} text={'add'} onClick={this.addCertificationToUser} />
					</div>
				</UIOverlayCard>
			</UIModal>
		);
	};
	renderRemoveCertModal = () => {
		const { showRemoveCertModal, certificationToRemove, editor } = this.state;
		const hideModal = () => {
			this.setState({ showRemoveCertModal: false });
		};

		return (
			<UIModal condition={showRemoveCertModal} hideModal={hideModal}>
				<UIOverlayCard hideModal={hideModal} title={'Remove certification'}>
					<p className='general-description'>{`Are you sure you would like to remove the certification "${certificationToRemove}" from ${editor.name}?`}</p>
					<div className='general-buttons-container'>
						<UIButton dark type={UIButton.FILL_TYPE} text={'remove'} onClick={() => this.removeCertificationFromUser(certificationToRemove)} />
					</div>
				</UIOverlayCard>
			</UIModal>
		);
	};
}

export default withApollo(connect(commonMapStateToProps, commonMapDispatchToProps)(IndividualEditor));
